import React, { useContext } from "react";
export const FormFieldGroupContext = React.createContext({});
/**
 * FormFieldGroup allows the user to group several form components into a group.
 * It allows the components inside to share the same status (ie: disabled)
 */
export const FormFieldGroup = ({ disabled, children }) => {
    // Pass down disabled from parent unless explicitly overridden
    const { disabled: disabledFromParent } = useContext(FormFieldGroupContext);
    const contextValue = React.useMemo(() => ({ disabled: disabled === undefined ? disabledFromParent : disabled }), [disabled, disabledFromParent]);
    return React.createElement(FormFieldGroupContext.Provider, { value: contextValue }, children);
};
